// Shared by React and Express. Keep this module helper-free CommonJS so the
// legacy CRA Babel pipeline does not inject ES imports into Node exports.
// UTF-16 counting is conservative: supplementary characters consume two units.
var SMS_MAX_LENGTH = 1600;
function result(count, valid, code, message) {
  return { count: count, limit: SMS_MAX_LENGTH, valid: valid, code: code, message: message };
}
function validateSms(message) {
  var count = typeof message === 'string' ? message.length : 0;
  if (typeof message !== 'string' || !message.trim()) {
    return result(count, false, 'SMS_MESSAGE_REQUIRED', 'Enter a message before sending.');
  }
  if (count > SMS_MAX_LENGTH) {
    return result(count, false, 'SMS_MESSAGE_TOO_LONG', 'Message is too long. Shorten it by ' + (count - SMS_MAX_LENGTH) + ' SMS characters before sending.');
  }
  return result(count, true, null, count === SMS_MAX_LENGTH ? 'Character limit reached.' : '');
}
function smsHelperText(message) {
  var validation = validateSms(message);
  return validation.count + ' / ' + validation.limit + ' SMS characters (emoji may count as two). ' + validation.message;
}
module.exports = { SMS_MAX_LENGTH: SMS_MAX_LENGTH, validateSms: validateSms, smsHelperText: smsHelperText };
